/**
 * React Query keys for dashboard
 */

export const queryKey = {
  getDashboardStats: 'DASHBOARD_GET_STATS',
  getQuoteDistribution: 'DASHBOARD_GET_DISTRIBUTION',
  getQuotesOverTime: 'DASHBOARD_GET_TIMELINE',
  getRecentActivity: 'DASHBOARD_GET_ACTIVITY',
  getPendingFollowups: 'DASHBOARD_GET_FOLLOWUPS',
  getQuoteAverage: 'DASHBOARD_GET_QUOTE_AVERAGE',
  getQuoteStats: 'DASHBOARD_GET_QUOTE_STATS',
  getQuoteFollowups: 'DASHBOARD_GET_QUOTE_FOLLOWUPS',
};
